module.exports = __webpack_public_path__ + "static/share-11fb026c5ef2e984e4a58580935d5f60.jpg";